import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=a8bf823a&"
import script from "./TemplateList.vue?vue&type=script&lang=js&"
export * from "./TemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8bf823a')) {
      api.createRecord('a8bf823a', component.options)
    } else {
      api.reload('a8bf823a', component.options)
    }
    module.hot.accept("./TemplateList.vue?vue&type=template&id=a8bf823a&", function () {
      api.rerender('a8bf823a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/ordertemplate/TemplateList.vue"
export default component.exports